import posthog from 'posthog-js';

// PostHog analytics client.
//
// Configured via env vars (CRA inlines REACT_APP_* at build time):
//   REACT_APP_POSTHOG_KEY   - your PostHog Project API key (phc_...)
//   REACT_APP_POSTHOG_HOST  - ingestion host (US cloud: https://us.i.posthog.com)
//
// If the key is missing we skip init so the app still runs (analytics no-op).

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

export const posthogEnabled = Boolean(POSTHOG_KEY);

if (posthogEnabled) {
  posthog.init(POSTHOG_KEY as string, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',
    // Only create person profiles for users we identify (cheaper, privacy-friendly).
    person_profiles: 'identified_only',
    // Capture pageviews (incl. SPA route changes) and engagement automatically.
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    // Session replay (must ALSO be enabled in PostHog project settings).
    // Inputs are masked so passwords / sensitive fields never appear in replays.
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true
    }
  });
} else {
  // eslint-disable-next-line no-console
  console.warn(
    'PostHog disabled: set REACT_APP_POSTHOG_KEY in .env to enable analytics.'
  );
}

export default posthog;
